import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import linkResolver from './linkResolver';

function withPreview(Component: any) {
    return withPrismicPreview(Component, [
        {
            repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
            linkResolver,
        },
    ]);
}

export { withPreview };
